export const PAGE_STATUS = {
  active: 'active',
  inactive: 'inactive',
} as const;

export enum UniqueContent {
  agreement = 'agreement',
  offer = 'offer',
  persons = 'persons',
  faq = 'faq',
  places = 'places',
  collections = 'collections',
  site_map = 'site_map',
}

type CommonPage = {
  description: string;
  external_link?: string;
  id: number;
  open_in_new_window: boolean;
  redirect: boolean;
  remote_id: string;
  seo_title?: string;
  seo_description?: string;
  show_in_footer: boolean;
  show_in_rules: boolean;
  site_section: string | null;
  slug: string;
  status: keyof typeof PAGE_STATUS;
  title: string;
};

export type Page =
  | (CommonPage & {
      link: string;
      unique_content: Exclude<
        keyof typeof UniqueContent,
        'places' | 'collections' | 'site_map'
      > | null;
    })
  | (CommonPage & {
      link: null;
      unique_content: Extract<
        keyof typeof UniqueContent,
        'places' | 'collections' | 'site_map'
      >;
    });
